import { getSpecificAddonGroupsWithOrderDetail } from '@cart-services/utils/get-specific-addon-groups-with-order-detail'
import { type OrderItem } from '@hooks-api/types/dataModel/fpOrder'
import { type WpSubshipSetting } from '@hooks-api/types/dataModel/wp'
import Collapse from '@mui/material/Collapse'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CollapseIcon } from '../shared/CollapseIcon'
import { ShipmentOrderItem } from '../shared/Orders/ShipmentOrderItem'

interface OrderItemsProps {
  orderItems: OrderItem[]
  subshipType?: WpSubshipSetting['type']
}

export function OrderItems({ orderItems, subshipType }: OrderItemsProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const productOrderItems = orderItems.filter(
    item => item.order_item_type === 'product' && item.addon_main_product_id === null,
  )
  const specificAddonOrderItems = getSpecificAddonGroupsWithOrderDetail(
    orderItems.filter(item => item.order_item_type === 'product' && item.addon_main_product_id !== null),
  )

  const hasMultipleOrderItems = productOrderItems.length > 1

  const handleToggleOpen = () => {
    setOpen(previousOpen => !previousOpen)
  }

  return (
    <VStack gap={3}>
      {productOrderItems[0] && (
        <ShipmentOrderItem
          key={productOrderItems[0].id}
          orderItem={productOrderItems[0]}
          subshipType={subshipType}
          specificAddonOrderItems={productOrderItems[0].variation_id != null ? specificAddonOrderItems[productOrderItems[0].variation_id] : undefined}
        />
      )}
      {hasMultipleOrderItems && (
        <>
          <Collapse in={open}>
            <VStack gap={3}>
              {productOrderItems.slice(1).map(orderItem => (
                <ShipmentOrderItem
                  key={orderItem.id}
                  orderItem={orderItem}
                  subshipType={subshipType}
                  specificAddonOrderItems={orderItem.variation_id != null ? specificAddonOrderItems[orderItem.variation_id] : undefined}
                />
              ))}
            </VStack>
          </Collapse>
          <Box display="flex" justifyContent="center">
            <Button variant="text" onClick={handleToggleOpen}>
              <HStack gap={1} alignItems="center" justifyContent="center">
                <Text variant="body" color={colors.grey500}>
                  {open
                    ? t('orderDetail.collapseAll', { defaultValue: '收合全部' })
                    : t('orderDetail.viewAll', { defaultValue: '查看全部' })}
                </Text>
                <CollapseIcon open={open} color={colors.grey500} />
              </HStack>
            </Button>
          </Box>
        </>
      )}
    </VStack>
  )
}
